<template>
  <section class="communityDetails">
    <div class="headerbg">
      <div class="leftImg">
        <img :src="deteliData.mainImg && deteliData.mainImg.image_url" alt="" @error="imgError">
      </div>
      <div class="rightImg">
        <div class="pei1">
          <img :src="defaultImgFn(0)" @error="imgError" alt="">
        </div>
        <div class="pei2">
          <img :src="defaultImgFn(1)" @error="imgError" alt="">
        </div>
        <div class="pei3">
          <img :src="defaultImgFn(2)" @error="imgError" alt="">
        </div>
        <div class="pei4">
          <img :src="defaultImgFn(3)" @error="imgError" alt="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="keyword">
        <div v-for="(item, index) in deteliData.keywords" :key="index"><span>{{ item }}</span></div>
      </div>
      <div class="title">
        <div class="head">{{ deteliData.project_full_name }}</div>
        <div class="diz"><img src="../../assets/img/1dianw.png" alt=""><span>{{ deteliData.project_address }}</span>
        </div>
        <p>{{ deteliData.description }}</p>
      </div>
      <div class="device">
        <div class="head">社区配套</div>
        <ul>
          <li v-for="(item, index) in deteliData.component_list">
            <div class="frame"><img :src="item.image_url" alt=""><span>{{item.title}}</span></div>
          </li>
        </ul>
      </div>
      <div class="other">
        <div class="fangx">
          <div class="head">社区房型</div>
          <div @click="openFrom" class="btn"><img src="../../assets/img/yuyue.png" alt=""><span>预约看房</span></div>
        </div>
        <ul class="clearfix" :style="widthStyle">
          <template v-if="houseList.length">
            <li v-for="(item, index) in houseList" :key="index" @click="goHouse(item)">
              <div class="img">
                <img :src="item.room_pic?item.room_pic[0]: defaultImg" @error="imgError" alt="">
              </div>
              <div class="price">
                <div class="des1">
                  <div class="p_title overflow-ellipsis1">{{ item.room_name }}</div>
                  <div class="num"><span>{{ item.month_price }}</span>元/月起</div>
                </div>
                <div class="des2">
                  <div>{{ item.house_style }}</div>
                  <div>{{ item.bed_num_str }} | {{ item.area }}m2</div>
                </div>
              </div>
            </li>
          </template>
          <template v-if="!houseList.length">
            <p class="undata">暂无社区房型</p>
          </template>
        </ul>
        <p :class="thinking?'more':'more close'" @click="more" v-if="houseList.length > 4">
          <span>{{ thinking ? 'more' : 'close' }} </span><img src="../../assets/img/more.png" alt=""></p>
      </div>
      <div class="map">
        <div class="head">
          <div class="m_title">社区位置及周边</div>
          <div class="diz"><img src="../../assets/img/1dianw.png" alt=""><span>{{ deteliData.project_address }}</span>
          </div>
        </div>
        <div class="mapContent">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="交通" name="交通" style="font-size: 16px">
            </el-tab-pane>
            <el-tab-pane label="购物" name="购物">
            </el-tab-pane>
            <el-tab-pane label="餐饮" name="餐饮">
            </el-tab-pane>
            <el-tab-pane label="医疗" name="医疗">
            </el-tab-pane>
          </el-tabs>
          <div class="biaiduMap" id="allmap">
          </div>
        </div>
      </div>
      <div class="communityList">
        <div class="head">其他社区推荐</div>
        <div class="tuij">
          <div class="imgk" v-for="(item, index) in communityList" :key="index" @click="goCommunityDetails(item)">
            <div class="img">
              <img :src="item.main_img?item.main_img:defaultImg" @error="imgError" alt="">
            </div>
            <div class="name">
              <p class="overflow-ellipsis1">{{ item.project_full_name }}</p>
              <p class="overflow-ellipsis1" :title="item.project_address"><i
                class="el-icon-location-outline"></i>{{ item.project_address }}</p>
            </div>
            <div class="mask"></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="预约看房"
      :visible.sync="dialogVisible"
      custom-class="myDialog"
    >
      <appointment ref="appointment" v-if="dialogVisible" @changeState="changeState"></appointment>
      <div class="btn">
        <span @click="submit" v-if="!type">提交</span>
        <span @click="dialogVisible = false" v-if="type">关闭</span>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
import {getProjectDetaliApi} from '../../services/api'
import appointment from '../../components/appointmentForm.vue'
import defaultImg from '../../assets/img/wutu.jpg'
import dadingw from '../../assets/img/login.png'

export default {
  data() {
    return {
      id: '',
      defaultImg: defaultImg,
      deteliData: {},
      dialogVisible: false,
      activeName: '交通',
      widthStyle: {
        height: '275px'
      },
      thinking: true,
      type: ''
    }
  },
  metaInfo() {
    if (this.deteliData && this.deteliData.project_full_name) {
      return {
        title: '乐璟项目 - ' + this.deteliData.project_full_name,
      }
    }
  },
  computed: {
    ...mapState({
      houseList: state => state.houseList
    }),
    ...mapGetters({
      communityList: 'getcommunityList',
    })
  },
  methods: {
    ...mapActions([
      'getProjectList',
      'getHouseList'
    ]),
    ...mapMutations([
      'setActiveCity'
    ]),
    defaultImgFn(index) {
      if (this.deteliData.PROJECT && this.deteliData.PROJECT[index]) {
        return this.deteliData.PROJECT[index]
      }
      return this.defaultImg
    },
    handleClick() {
      this.baiduMap()
    },
    submit() {
      this.$refs.appointment.submit()
    },
    more() {
      if (this.thinking) {
        let row = Math.ceil(this.houseList.length / 4)
        this.widthStyle.height = row * 275 + row * 10 + 'px'
      } else {
        this.widthStyle.height = '275px'
      }
      this.thinking = !this.thinking
    },
    goCommunityDetails(item) {
      if (process.env.VUE_APP_PATH !== '/') {
        window.open(`${process.env.VUE_APP_PATH}/communityDetails/${item.id}.html`)
      } else {
        window.open(`/communityDetails/${item.id}.html`)
      }
    },
    goHouse(item) {
      if (process.env.VUE_APP_PATH !== '/') {
        window.open(`${process.env.VUE_APP_PATH}/houseDetails/${item.id}.html`)
      } else {
        window.open(`/houseDetails/${item.id}.html`)
      }
    },
    openFrom() {
      this.type = ''
      this.dialogVisible = true
    },
    getDeteil() {
      getProjectDetaliApi(this.id).then(res => {

        this.deteliData = res.hotel_project
        this.deteliData.keywords = this.deteliData.keyword && this.deteliData.keyword.split(' ');
        this.deteliData.COMPONENT = [];
        this.deteliData.PROJECT = [];
        this.baiduMap()
        this.getProjectList({
          page_num: 1,
          page_size: 3,
          id: this.deteliData.city_id
        })
        this.getHouseList({
          page_num: 1,
          page_size: 3,
          city_id: this.deteliData.city_id,
          project_id: this.deteliData.id
        })
        if (this.deteliData.image_list) {
          for (let v of this.deteliData.image_list) {
            if (v.image_type === 'COMPONENT') {
              this.deteliData.PROJECT.push(v)
            } else {
              if (v.title === '主图') {
                this.deteliData.mainImg = v
              }
              this.deteliData.PROJECT.push(v.image_url)
            }
          }
        }
        if (res.device_pic) {
          for (let v of res.device_pic) {
            this.deteliData.COMPONENT.push(v)
          }
        }
        this.setActiveCity({city_id: this.deteliData.city_id, project_id: this.deteliData.id})
      })
    },
    baiduMap() {

      var map = new BMap.Map('allmap') // 创建地图实例
      var local = new BMap.LocalSearch(map, {renderOptions: {map: map, autoViewport: false, selectFirstResult: false}})
      var point = new BMap.Point(this.deteliData.longitude, this.deteliData.latitude) // 创建点坐标
      map.centerAndZoom(point, 15) // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true) //开启鼠标滚轮缩放

      map.addControl(new BMap.NavigationControl())
      map.addControl(new BMap.ScaleControl())
      map.addControl(new BMap.OverviewMapControl())
      map.addControl(new BMap.MapTypeControl({
        mapTypes: [
          BMAP_NORMAL_MAP
        ]
      }))
      local.searchNearby(this.activeName, point, 1000); // address 为传递的搜索文本

      //map.setMapStyle({ style: 'midnight' }) //地图风格
      var myIcon = new BMap.Icon(dadingw, new BMap.Size(106, 90), {
        anchor: new BMap.Size(53, 75),
      })
      var marker = new window.BMap.Marker(point, {icon: myIcon}) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中

      //提示信息
      // var infoWindow = new BMap.InfoWindow('这是提示信息')
      // 鼠标移上标注点要发生的事
      // marker.addEventListener('mouseover', function() {
      //     this.openInfoWindow(infoWindow)
      // })

      // 鼠标移开标注点要发生的事
      marker.addEventListener('mouseout', function () {
        //this.closeInfoWindow(infoWindow)
      })
    },
    changeState(type) {
      this.type = type
    },
    imgError(err) {
      err.path[0].src = this.defaultImg
    }
  },
  mounted() {
    this.id = this.$route.params.id.substr(0, this.$route.params.id.length - 5)
    this.getDeteil()
  },
  components: {
    appointment
  }
}
</script>

<style lang="stylus">
.communityDetails
  font-size 14px
  font-family PingFangSC-Regular
  padding-bottom 112px

  .undata
    color #d8d4d4
    margin-left 10px

  /* 去除百度地图版权那行字 和 百度logo */

  .map > .BMap_cpyCtrl
    display: none !important

  .map .anchorBL
    display: none !important

  .headerbg
    height 552px
    display flex

    .leftImg
      width 66.66%
      height 552px

      img
        width 100%
        height 100%

    .rightImg
      width 33.33%
      height 552px

      div
        width calc(50% - 3px)
        height 273px
        float left

        img
          width 100%
          height 100%

      .pei1
        background #00A5CA

      .pei2
        float right
        background #0805CA

      .pei3
        margin-top 6px
        background #07A0CA

      .pei4
        margin-top 6px
        float right
        background #060000

  .content
    padding-top 20px
    width 1120px
    margin 0 auto

    .keyword
      overflow hidden
      color #00B8D4
      font-size 18px

      div
        border 1px solid #00B8D4
        margin-right 16px
        float left
        border-radius 30px
        padding 9px 28px

    .title
      margin-top 47px

      .head
        font-family PingFangSC-Medium
        color #222
        font-size 46px
        font-weight 500

      .diz
        margin-top 22px
        font-size 18px
        color #999999
        display: flex
        align-items: center

        img
          width 14px
          height 17px
          margin-right 10px

      p
        margin-top 24px
        font-size 18px
        color #666666
        font-weight 400
        line-height 33px

    .device
      margin-top 90px

      .head
        font-family PingFangSC-Medium
        color #272727
        font-size 32px
        font-weight 500

      ul
        overflow hidden
        padding 35px 50px 20px 50px

        li
          margin-bottom 55px
          width 20%
          float left

          .frame
            width: 30%
            text-align: center

            img
              width 44px
              height 36px

            span
              white-space nowrap
              margin-top 18px
              display block

    .other
      .fangx
        display: flex;
        justify-content: space-between

        .head
          font-family PingFangSC-Medium
          color #272727
          font-size 32px
          font-weight 500

        .btn
          padding 10px 22px 10px 18px
          color #fff
          background: linear-gradient(90deg, rgba(127, 241, 251, 1), rgba(0, 184, 212, 1))
          box-shadow: 0px 2px 8px 1px rgba(80, 181, 208, 0.29)
          font-size 18px
          border-radius 32px
          display flex
          align-items center
          transition all 0.3s
          cursor pointer

          &:hover
            box-shadow: 0px 2px 8px 1px rgba(80, 181, 208, 0.7)
            transition all 0.3s

          img
            width 35px
            height 32px
            margin-right 13px

      .more
        // margin-top 25px
        display: flex
        align-items: center
        justify-content: center

        span
          cursor pointer
          font-size 22px
          color #00B8D4
          display block
          margin-right 3px

        img
          transition all 0.3s
          cursor pointer
          width 12px
          height 11px
          margin-top: 5px
          transform: rotate(0deg)

      .close
        img
          transition all 0.3s
          transform: rotate(180deg)

      ul
        overflow hidden
        height: 275px
        padding-top 32px
        transition all 0.5s

        li
          float left
          margin-right 12px
          box-shadow: 0px 2px 15px 3px rgba(113, 130, 132, 0)
          transition all 0.3s
          overflow hidden
          border-radius 5px 5px 0px 0px
          width 270px
          height 263px
          margin-bottom 20px
          cursor pointer

          &:nth-child(4n+4)
            margin-right 0px

          .img
            height 190px
            background-color #00FFFF

            img
              width 100%
              height 100%

          .price
            border-radius 0px 0px 5px 5px
            padding 13px 8px 11px 8px
            border 1px solid #E3E3E3

            .des1
              display flex
              align-items center
              justify-content space-between

              .p_title
                font-family PingFangSC-Medium
                width 150px
                color #333333
                font-weight 600

              .num
                span
                  color #FF625A
                  font-size 20px

            .des2
              margin-top 2px
              color: #999999
              font-size 12px
              display flex
              justify-content space-between

          &:hover
            transition all 0.5s
            transform: translate(5px, 5px)
            box-shadow: 0px 2px 15px 3px rgba(113, 130, 132, 0.16)

    .map
      padding 50px 0 65px 0

      .head
        display flex
        align-items flex-end

        .m_title
          font-family PingFangSC-Medium
          color #272727
          font-size 32px
          font-weight 500

        .diz
          font-size 18px
          color #666666

          img
            width 14px
            height 17px
            margin 0 11px 0 27px

      .mapContent
        margin-top 20px

        .biaiduMap
          height 500px
          background-color #00B8D4

        .el-tabs__item
          font-size 16px
          color #666
          font-weight: 400
          font-family PingFangSC-Medium

        .is-active
          color #333
          font-weight: 600

        .el-tabs__nav-wrap::after
          height 0px

    .communityList
      .head
        font-family PingFangSC-Medium
        color #272727
        font-size 32px
        font-weight 500

      .tuij
        margin-top 54px
        display flex

        .imgk
          cursor pointer
          overflow hidden
          position relative
          width 360px
          height 250px
          box-sizing border-box
          background-color #00B8D4
          border 4px #fff solid
          margin-left 20px

          &:hover
            border 4px #00B8D4 solid
            box-shadow: 0px 2px 26px 3px rgba(4, 6, 15, 0.06)

          // .name
          //   transform:translate(0px,-53px)
          // .mask
          //   transform: translate(0px, -60px)

          &:first-child
            margin-left 0 !important

          .img
            width 100%
            height 100%

            img
              width 100%
              height 100%

          .mask
            transform: translate(0px, -60px)
            transition all 0.5s
            width: 360px
            height: 60px
            opacity: 0.5
            background: #000
            position: absolute

          .name
            transform: translate(0px, -53px)
            color: #fff
            z-index: 99
            width: 350px
            position: absolute
            transition all 0.5s
            margin-left: 5px

            p:first-child
              font-size: 22px
              font-weight: 500

            p:last-child
              font-size: 12px
              font-weight: 400
              margin-top: 5px

              i
                margin-right: 3px

.myDialog
  width 840px
  font-family PingFangSC-Regular

  .el-dialog__header
    font-family PingFangSC-Regular
    padding 16px 25px
    background #00B8D4

    .el-dialog__title
      color: #fff

    i
      font-size 28px
      color: #fff

  .el-dialog__body
    .btn
      text-align center

      span
        font-weight 400
        font-size 16px
        color #fff
        background-color #00B8D4
        padding 12px 42px
        border-radius 5px
        cursor pointer
</style>
